import { ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import classnames from 'classnames';
import { isDarkMode } from '@localstack/services';

import LogoSvg from './localstack-icon-monochromatic.svg';

const LOGO_DARK_MODE_FILL = '#737373';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .path': {
        fill: isDarkMode(theme) ? LOGO_DARK_MODE_FILL : undefined,
      },
      marginBottom: theme.spacing(-1),
    },
  }),
);

export const LogoIcon = (): ReactElement => {
  const classes = useStyles();

  return <LogoSvg className={classnames(classes.root)} />;
};
